import React from 'react';
import "./index.css"
import BsyRadioGroup from "../../../BsyRadioGroup";
import BsyDialog from "../../../../components/BsyDialog";
import BsyDateTime from '../../../../components/BsyDateTime';
import AlertListSelectAppPopupPane from "../../../../components/BsyAlertListDetail/selectAppPopupPane";
import _ from 'lodash';
import classNames from "classnames"
class BsyConfigurationBulletinStaicConfig extends React.Component {
    constructor(props) {
        console.log(11, props)
        super(props);
        this.state = {
            title: props.staticData.title || "",
            date: props.staticData.date,
            linkType: props.staticData.linkType || 'externalLink',
            interModel: props.staticData.interModel || {}
        };
        this.theModelink = props.staticData.link || ""
        this.theModelFromData = props.staticData.interModel || {}
    }
    linkEdit = (event) => {
        this.theModelink = event.target.value;
    };
    TitleEdit = (event) => {

        this.setState({
            title: event.target.value.slice(0, 40)
        })
    }
    emitStaciComplete = () => {
        let Obj = {
            title: this.state.title,
            date: this.state.date,
            linkType: this.state.linkType,
            link: this.theModelink,
            interModel: this.theModelFromData,
        }
        this.props.emitStaciComplete(Obj)
    }
    getPopupValue = (ref) => {
        if(!_.isEmpty(ref.appinfo)){
            this.theModelFromData = ref
        }
     
    }
    deleteInterModelFn = (event) => {
        event.stopPropagation()
        this.theModelFromData = {}
        this.setState({
            interModel: {},
        });
    }
    chooselinkType = () => {
        console.log(123123)
        BsyDialog({
            title: React.language("form.select"),
            height: 540,
            width: 720,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                return (
                    <AlertListSelectAppPopupPane
                        // onlyForm={true}
                        noHome={true}
                        showTypeList={['dash']}
                        appid={this.state.interModel.appid}
                        formid={this.state.interModel.formid}
                        getValue={this.getPopupValue}
                    />
                );
            },
            onOk: () => {
                this.setState({
                    interModel: this.theModelFromData
                })
            }
        });
    }


    render() {
        return <div className='configuration-bulletin-static-page'>
            <div className='page-title'>{React.language("dashboard.Static.data.source")}</div>
            <div className='ok-btn' onClick={() => {
                this.emitStaciComplete()
            }}>{React.language("done")}</div>
            <div>
                <div className='title'>{React.language("label")}</div>
                <div className="input-box input-title">
                    <input placeholder="请输入标题"  className={classNames(this.state.title.length > 40 ? "active t-input" : "t-input")} Value={this.state.title || ""}
                        onInput={(event) => {
                            this.TitleEdit(event);
                        }} />
                </div>
            </div>
            <div className='box'>
                <div className='title'>{React.language("date")}</div>
                <BsyDateTime
                    {
                    ...{
                        width: 274,
                        format: 'yyyy-MM-dd',
                        value: this.state.date,
                        start: '+30m',
                        end: '+30d',
                        onStopEdit: (val) => {
                            this.setState({
                                date: val
                            })
                        }
                    }
                    }
                ></BsyDateTime>
            </div>
            <div className='box'>
                <div className='title'>{React.language("dashboard.link.type")}</div>
                <div className="radio-box">
                    <BsyRadioGroup layout={"horizontal"} value={this.state.linkType}
                        items={[
                            {
                                value: "internalPage",
                                text: React.language("dashboard.open.internal.page"),
                            },
                            {
                                value: "externalLink",
                                text: React.language("dashboard.open.external.link"),
                            },
                        ]}
                        onStopEdit={(e) => {
                            this.setState({
                                linkType: e,
                            });
                        }}
                    />
                </div>
                {this.state.linkType === "internalPage" && (
                    <div className={classNames(_.isEmpty(this.state.interModel) ? "choose-type has-up" : "choose-type has-close")} onClick={() => {
                        this.chooselinkType()
                    }}>
                        {
                            _.isEmpty(this.state.interModel) && <span>{React.language("select.form")}</span>
                        }
                        {
                            !_.isEmpty(this.state.interModel) && <div className="has-icon">
                                <span className={"parent-icon color-cover-" + this.state.interModel.appinfo.style.color} >
                                    <span className={"imgbg-bby-app imgbg-bby-app-" + (this.state.interModel.appinfo.style.icon)}></span>
                                </span>
                                <span>{this.state.interModel.appinfo.appname}</span>
                                <span className="line">—</span>
                                {/* <i className={"icon-bsy-form "+this.state.titleModelFromData.appinfo.style.newIcon?"icon-new-bsy-form-"+this.state.titleModelFromData.appinfo.style.newIcon:"icon-bsy-form-"+this.state.titleModelFromData.icon}></i> */}
                                <span>{this.state.interModel.name}</span>
                            </div>
                        }
                        <i className="icon-down1"></i>
                        <i className="icon-dingding-guide-close close" onClick={this.deleteInterModelFn}></i>
                    </div>
                )}
                {this.state.linkType === "externalLink" && (
                    <div className="input-box">
                        <input placeholder="请输入链接" className="t-input" defaultValue={this.theModelink || ""}
                            onInput={(event) => {
                                this.linkEdit(event);
                            }}
                        ></input>
                    </div>
                )}
            </div>


        </div>;
    }
}


export default BsyConfigurationBulletinStaicConfig;